<template>
  <div class="footer_aeskulab">
    <div class="d-flex justify-start align-center">
      <Container class="footer_companies__container py-12">
        <div
          class="d-flex justify-space-between align-start align-lg-center flex-column flex-lg-row"
        >
          <div class="text_box">
            <v-img
              alt=""
              height="32"
              contain
              position="left center"
              :src="$asset('img/logos/ulekare_hc-logo.svg')"
            />
            <div class="mt-5">
              {{ $t('aeskulab.footer.leftText') }}
            </div>
            <AppButtons
              class="mt-6"
              link-app-store="https://apps.apple.com/cz/app/ul%C3%A9ka%C5%99e-cz/id1488852248"
              link-google-play="https://play.google.com/store/apps/details?id=cz.ulekare.app&hl=cs&gl=US"
              google-first
            />
          </div>
          <div class="mt-8 mt-lg-0 text_box">
            <v-img
              alt=""
              height="32"
              contain
              position="left center"
              :src="$asset('img/logos/unilabs_logo.svg')"
              class="cursor-pointer"
              @click="logoRedirect"
            />
            <div class="mt-5">
              {{ $t('aeskulab.footer.rightText') }}
            </div>
          </div>
        </div>
      </Container>
    </div>
    <div class="py-4 py-md-6 white">
      <Container class="text-center">
        <div v-if="$vuetify.breakpoint.lgAndUp" class="d-flex justify-center align-center">
          <div class="text-body-small grey-darken-1--text pr-2">
            <span
              v-html="$t('aeskulab.footer.copyright', { thisYear: new Date().getFullYear() })"
            />
          </div>
          <div v-for="(item, key) in linkList" :key="key" class="text-body-small px-2 companyLink">
            <a
              v-if="item.linkType === 'external'"
              :href="item.link"
              :target="item.target ? item.target : ''"
            >
              {{ item.title }}
            </a>
            <router-link
              v-else
              :to="
                $localePath({
                  name: item.aeskulabLink ? item.aeskulabLink : item.link,
                  query: $route.query
                })
              "
              :target="item.target ? item.target : ''"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>
        <div v-else>
          <LinkList :items="linkList" class="mb-8" />
          <div class="text-left grey-darken-1--text text-body-small">
            <span
              v-html="$t('aeskulab.footer.copyright', { thisYear: new Date().getFullYear() })"
            />
          </div>
        </div>
      </Container>
    </div>
  </div>
</template>

<script>
import Container from '@/components/Atoms/Container';
import AppButtons from '@/components/Atoms/AppButtons';
import LinkList from '@/components/Molecules/LinkList';

export default {
  name: 'FooterAeskulab',
  components: { LinkList, AppButtons, Container },
  computed: {
    linkList() {
      return this.$t('footer.companyList', { returnObjects: true }).filter(
        link => link.aeskulab === undefined
      );
    }
  },
  methods: {
    logoRedirect() {
      this.gtmPush({
        event: 'button_click',
        'button.type': 'aeskulab logo',
        'button.detail': 'footer',
        service: 'aeskulab'
      });
      this.newTab('https://www.aeskulab.cz/cs');
    }
  }
};
</script>

<style lang="scss" scoped>
.footer_aeskulab {
  width: 100%;
  max-width: 100%;

  .companyLink {
    border-left: $border-width solid $grey-lighten;
  }

  .text_box {
    width: 529px;
    max-width: 100%;
  }
}
</style>
